import { readonly } from "vue";

export default {
  lang: {
    choose: '语言/Language',
    zhcn: '简体中文',
    zhtw: '繁體中文(臺灣)',
    en: 'English',
    es: 'Español',
    ru: 'Русский',
    de: 'Deutsch',
    sv: 'Svenska',
    ja: '日本語',
    changeok: '语言切换成功！'
  },
  btn: {
    ok: '确 定',
    cancel: '取消',
    cont: 'Continue'
  },
  menu: {
    upload: '上传',
    newfolder: '新建文件夹',
    del: '删除',
    up: '上级目录',
    refresh: '刷新',
    dfu: 'DFU',
  },
  status: {
    connected: '已连接，版本： ',
    version: '版本：',
    mac: 'MAC 地址： ',
    loading: '加载中…',
  },
  conn: {
    connect: '连接',
    connecting: '连接中…',
    disconnect: '断开',
    consuccess: '已成功连接到Pixl.js!',
    disconnected: 'Pixl.js已经断开连接!',
    connfailed: 'Pixl.js连接失败!'
  },
  labels: {
    name: '文件',
    size: '大小',
    type: '类型',
    remark: '备注'
  },
  contxmenu: {
    del: '删除…',
    rename: '重命名…',
    prop: '元信息…',
    format: '格式化…'
  },
  properties: {
    title: '特性',
    remark: '备注',
    entermsg: '请输入备注',
    attrib: '属性',
    hide: '隐藏',
    readonly: '只读',
    errupdate: '更新备注失败',
    remarktoolong: '备注最大只能是90字节，即90个字符或30个汉字！（当前: ',
    remarktoolongend: ' 字节）'
  },
  upload: {
    title: '上传',
    drag: '将文件拖到此处，或 ',
    click: '点击上传',
    maxsize: '文件路径总长度不能超过63个字节，超过部分会被截断。',
    maxname: '文件名不能超过47个字节，超过部分会被截断。',
    closetitle: '确认关闭？',
    closemessage: '关闭将清空上传记录。',
    errupload: '上传失败'
  },
  format: {
    title: '格式',
    messrow1a: '是否格式化 ',
    messrow1b: ' ?',
    messrow2: '格式化会删除所有数据！',
    messrow3: '格式化可能需要10秒钟左右，请耐心等待。',
    formatok: '格式化完成',
    formaterr: '格式化失败!'
  },
  del: {
    title: '删除',
    message: '是否删除 ',
    messageend: ' ?',
    error: '删除失败 ',
    deleteok: '删除文件成功'
  },
  dfumode: {
    title: 'DFU 模式',
    startconfirm: '是否进入DFU模式?',
    updateconfirm: '进入DFU模式成功，是否打开DFU升级页面？',
    updatetitle: '提示'
  },
  oldfirm: {
    title: '升级提示',
    message: '您设备的固件版本过低，请更新最新版本固件再使用上传功能'
  },
  newfolder: {
    title: '新建文件夹',
    message: '请输入文件夹名',
    newfoldererr: '创建文件夹失败 '
  },
  rename: {
    title: '改名',
    message: '请输入新的文件名 ',
    errrename: '重命名失败 ',
    nametoolong: '文件路径最大不能超过63个字节',
    pathtoolong: '文件名最大不能超过47个字节'
  },
  drive: {
    message: '(磁盘不可用[错误代码: ',
    messageend: '])'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/zh_Hans.js